import React, { useState, useEffect, memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SettingsIcon from '@mui/icons-material/Settings';
import { useTranslation } from 'react-i18next';
const Navigation = memo(() => {
  const { t } = useTranslation();

  const location = useLocation(); // Hook to get current location
  const Menus = [
    { name: t("Nav.Home"), icon: <HomeIcon sx={{color:"#F7F2FB"}}/>, dis: "translate-x-[36vw]", path: "/" },
    { name: t("Nav.Device"), icon: <LocalPrintshopIcon sx={{color:"#F7F2FB"}}/>, dis: "translate-x-[15vw]", path: "/device" },
    { name: t("Nav.Support"), icon: <SupportAgentIcon sx={{color:"#F7F2FB"}}/>, dis: "translate-x-[25vw]", path: "/support" },
    { name: t("Nav.Setting"), icon: <SettingsIcon sx={{color:"#F7F2FB"}}/>, dis: "translate-x-[35vw]", path: "/setting" },
  ];

  const [active, setActive] = useState();

  // Update active state based on current URL
  useEffect(() => {
    const currentPath = location.pathname;
    const activeIndex = Menus.findIndex(menu => menu.path === currentPath);
    setActive(activeIndex !== -1 ? activeIndex : 0);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname ]);

  return ( 
    <>
    <div  className='w-full bg-[#ffff] h-[5.2rem] fixed left-0 bottom-0 shadow-t-md  '></div>
    <div  className="bg-[#512C63] max-h-[4.4rem]  fixed w-full left-0 bottom-0  z-10">
      <ul className="flex justify-center ">
       
        {Menus.map((menu, i) => (
      
       
          <li key={menu.name} className="mx-6 flex justify-center items-center">
          <span
          className={`z-0 bg-[#512C63] duration-500   border-[5px] border-[#FFFF] h-16 w-16 absolute 
          -top-5 rounded-full  ${i === active ? "box": "hidden"}`}
        >
               <span
            className="w-6 h-8  absolute top-[15px] -left-[28px] 
            rounded-tr-[22px] shadow-myShadow1 -z-10"
          ></span>
          <span
            className="w-6 h-8 bg-tra absolute top-[15px] -right-[28px] 
          rounded-tl-[22px] -z-10 shadow-myShadow2 "
          ></span>
        </span>
            <Link 
              to={menu.path}
              className="flex flex-col text-center py-2"
              >
              <span
                className={`z-20 text-xl cursor-pointer duration-500 mb-1 ${
                  i === active && "-mt-2  text-[#F7F2FB}"
                }`}
              >
                 {React.cloneElement(menu.icon, {
                   sx: { color: i === active ? "#F7F2FB" : "#BAB3BD" }
                })}
              </span>
              <span
                className={` text-sm font-vazir  duration-700 opacity-100 ${i === active ? "mt-4  text-[#F7F2FB]":"text-[#BAB3BD]"}`}
              >
                {menu.name}
              </span>
            </Link>
          </li>

        ))}
      </ul>
    </div>
      </>
  );
});

export default Navigation;
